import { useMemo } from 'react';

import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { FIELD_NAMES } from '../constants';
import useIndustries from './useIndustries';

export default function useIndustryField({ validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    required: formatMessage(
      { id: 'shopping.page.industry.form.field.error.required' },
      { label: 'Industry' }
    )
  };

  const {
    field,
    fieldState: { error: validationError }
  } = useController({
    defaultValue: '',
    name: FIELD_NAMES.INDUSTRY,
    rules: { ...defaultValidation, ...validation }
  });

  const {
    data: industries,
    error: industriesError,
    loading: loadingIndustries
  } = useIndustries({});

  const error = validationError || industriesError;

  // Sort from A to Z starting with numbers
  const sortedOptions = useMemo(() => {
    return (industries || []).sort((a, b) => a.label.localeCompare(b.label));
  }, [industries]);

  return {
    error,
    field: {
      ...field,
      value: field.value ?? ''
    },
    options: sortedOptions,
    loading: loadingIndustries
  };
}
